import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Xedientonghop from "components/Xedien/Xedientonghop.js";
export default function BCXedien() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo tháng xe điện",
            tabContent: <Xedientonghop />,
          },
        ]}
      />
    </div>
  );
}
